import { render, staticRenderFns } from "./activityFile.vue?vue&type=template&id=4fa5ead2&scoped=true"
import script from "./activityFile.vue?vue&type=script&lang=js"
export * from "./activityFile.vue?vue&type=script&lang=js"
import style0 from "./activityFile.vue?vue&type=style&index=0&id=4fa5ead2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5ead2",
  null
  
)

export default component.exports